import { useQuery } from '@tanstack/react-query';
import { getProcessedTimesheetDetails } from '../Services/ProcessedTimesheetService';

const useGetProcessedTimesheetDetails = (params, options) =>
    useQuery(
        ['processedTimesheetDetails', params],
        () => getProcessedTimesheetDetails(params),
        options
    );

export default useGetProcessedTimesheetDetails;
